import LoginScreen from "./components/Screens/LoginScreen/LoginScreen";
import ForgotPasswordScreen from "./components/Screens/ForgotPasswordScreen/ForgotPasswordScreen";
import { ReadleeFirebaseProvider } from "./services/firebase/ReadleeFirebaseProvider";
import { RootState, store } from "./state/configureStore";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import SignUpScreen from "./components/Screens/SignUpScreen/SignUpScreen";
import BookScreen from "./components/Screens/BookScreen/BookScreen";
import StudentHomeScreen from "./components/Screens/StudentHomeScreen/StudentHomeScreen";
import TeacherHomeScreen from "./components/Screens/Teacher/TeacherHomeScreen/TeacherHomeScreen";
import OnboardingScreen from "./components/Screens/OnboardingScreen/OnboardingScreen";
import AssessmentScreen from "./components/Screens/AssessmentScreen/AssessmentScreen";
import StudentPerformanceScreen from "./components/Screens/StudentPerformanceScreen/StudentPerformanceScreen";
import { connect } from "react-redux";
import AppLoadingScreen from "./components/Loading/AppLoadingScreen";
import ProjectPaperbackAdmin from "./components/Screens/ProjectPaperback/ProjectPaperbackAdmin";
import { deployment } from "./utils/DeploymentSettings";
import { JoinClassRedirectScreen } from "./components/JoinClass";

// see https://github.com/ReactTraining/react-router/issues/4278#issuecomment-278477167
function triggerAppCues({ isConnectingUser, profile }: InternalAppProps) {
  return () => {
    if (isConnectingUser) return null;
    if (!isConnectingUser && profile?.lastLoginDay && !profile.uid) return null;
    if (deployment !== "production") return null;

    const { Appcues } = window as any;
    try {
      Appcues.page();
      if (profile) {
        Appcues.identify(profile.email, { userType: profile.userType });
      } else {
        Appcues.identify("not-logged-in");
      }
    } catch (err) {
      console.error(err);
    }
    return null;
  };
}
type InternalAppProps = ReturnType<typeof mapStateToProps>;
function InternalApp(props: InternalAppProps) {
  return (
    <ReadleeFirebaseProvider store={store}>
      <BrowserRouter>
        <div className="App">
          <div className="appMasterDiv">
            <Route path="/" component={triggerAppCues(props)} />
            <Switch>
              <Route path="/Login" component={LoginScreen} />
              <Route path="/sign-up" component={SignUpScreen} />
              <Route path="/Book" component={BookScreen} />
              <Route path="/Onboarding" component={OnboardingScreen} />
              <Route path="/Assessment" component={AssessmentScreen} />
              <Route path="/StudentPerformance" component={StudentPerformanceScreen} />
              <Route path="/ProjectPaperbackAdmin" component={ProjectPaperbackAdmin} />
              <Route path="/ForgotPassword" component={ForgotPasswordScreen} />
              <Route path="/j/:classCode" component={JoinClassRedirectScreen} />
              <Redirect from="/Home" to="/" />
              {props.assumedUserType === "student" && <Route path="/" component={StudentHomeScreen} />}
              {props.assumedUserType === "teacher" && <Route path="/" component={TeacherHomeScreen} />}
              {props.assumedUserType === "" && <Route path="/" component={AppLoadingScreen} />}
            </Switch>
          </div>
        </div>
      </BrowserRouter>
    </ReadleeFirebaseProvider>
  );
}

const mapStateToProps = (state: RootState) => {
  return {
    profile: state.currentUserState.currentUser,
    isConnectingUser: state.currentUserState.isConnectingUser,
    isLoggedIn: state.currentUserState.currentUser !== undefined,
    isConnectingSettings: state.currentUserState.isConnectingSettings,
    userSettings: state.currentUserState.currentUserSettings,
    assumedUserType: state.currentUserState.assumedUserType,
  };
};

export default connect(mapStateToProps)(InternalApp);
